import * as lead from '../types/lead'
import { removeProduct, updateAllFees } from './cart'

export const openModalCnpj = () => ({
    type: lead.OPEN_MODAL_CNPJ
})

export const closeModalCnpj = () => ({
    type: lead.CLOSE_MODAL_CNPJ
})

export const openModalLead = () => ({
    type: lead.OPEN_MODAL_LEAD
})

export const closeModalLead = () => ({
    type: lead.CLOSE_MODAL_LEAD
})

export const openModalRegistrationIrregularity = (removedProducts) => ({
    type: lead.OPEN_MODAL_REGISTRATION_IRREGULARITY,
    removedProducts
})

export const closeModalRegistrationIrregularity = () => ({
    type: lead.CLOSE_MODAL_REGISTRATION_IRREGULARITY
})

export const openModalPollingError = () => ({
    type: lead.OPEN_MODAL_POLLING_ERROR
})

export const closeModalPollingError = () => ({
    type: lead.CLOSE_MODAL_POLLING_ERROR
})

export const openModalProductExisting = () => ({
    type: lead.OPEN_MODAL_PRODUCT_EXISTING
})

export const closeModalProductExisting = () => ({
    type: lead.CLOSE_MODAL_PRODUCT_EXISTING
})

export const openModalMaintenanceProduct = () => ({
    type: lead.OPEN_MODAL_MAINTENANCE_PRODUCT
})

export const closeModalMaintenanceProduct = () => ({
    type: lead.CLOSE_MODAL_MAINTENANCE_PRODUCT
})

export const setNewCompany = () => ({
    type: lead.SET_NEW_COMPANY
})

export const setOldCompany = () => ({
    type: lead.SET_OLD_COMPANY
})

export const setLoading = () => ({
    type: lead.SET_LOADING
})

export const removeLoading = () => ({
    type: lead.REMOVE_LOADING
})

export const closeAllModal = () => ({
    type: lead.CLOSE_ALL_MODAL
})

export const setCnpjLead = (value) => ({
    type: lead.SET_CNPJ_LEAD,
    value
})

export const updateLead = (name, email, phone) => ({
    type: lead.UPDATE_LEAD,
    name,
    email,
    phone
})

export const setCnpjError = () => ({
    type: lead.SET_CNPJ_ERROR
})
export const removeCnpjError = () => ({
    type: lead.REMOVE_CNPJ_ERROR
})

export const continueShopping = () => (dispatch, getState) => {
    let state = getState()
    const unavailableProductCodes =
        state.cart.documentVerification.unavailableProductCodes

    unavailableProductCodes.forEach((product) =>
        dispatch(removeProduct(product))
    )
    dispatch(closeModalProductExisting())
    dispatch(closeModalRegistrationIrregularity())
    dispatch(updateAllFees())
}

export const reset = () => ({
    type: lead.RESET
})
